// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/HomePage.css */

/* Navbar section */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #2d3e75; /* Dark blue background */
}

.navbar-logo {
  font-size: 1.8rem;
  font-weight: bold;
  color: white;
}

.logo-skill {
  color: #f39423; /* Orange for "SKIL" */
}

.logo-lab {
  color: white; /* White for "LAB" */
}


.navbar-links {
  list-style: none;
  display: flex;
  gap: 20px;
}

.navbar-links li {
  display: inline-block;
}

.nav-link-home {
  text-decoration: none;
  color: white; /* Default color */
  font-size: 1.2rem;
  font-weight: bold;
  transition: color 0.3s ease; /* Smooth transition on hover */
}

.nav-link-home:hover {
  color: #f39423 !important; /* Orange color on hover */
}




.initpage-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
    background-color: white;
  }
  
  /* Header Styling */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: white;
  }
  
  .logo-section {
    display: flex;
    align-items: center;
  }
  
  .logo-text {
    font-size: 2rem;
    font-weight: bold;
  }
  
  .eu-logo .eu-image {
    width: 60px;
  }
  
  /* Main Content Styling */
  .content {
    text-align: center;
    padding: 40px;
  }
  
  .content-heading {
    font-size: 2.5rem;
    color: #333;
  }
  
  .content-description {
    font-size: 1.2rem;
    margin-top: 20px;
    line-height: 1.5;
    color: #555;
  }
  
  /* Map Section Styling */
  .map-section {
    text-align: center;
    margin-top: 40px;
  }
  
  .map-image {
    width: 80%;
    max-width: 600px;
  }
  
  /* Footer or Bottom EU Section */
  .eu-logo-container {
    display: flex;
    justify-content: flex-start;
    padding: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/init-page.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,YAAY,EAAE,oBAAoB;AACpC;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY,EAAE,kBAAkB;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B,EAAE,+BAA+B;AAC9D;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;;;;AAKA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,2BAA2B;IAC3B,aAAa;EACf","sourcesContent":["/* src/HomePage.css */\r\n\r\n/* Navbar section */\r\n.navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  background-color: #2d3e75; /* Dark blue background */\r\n}\r\n\r\n.navbar-logo {\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  color: white;\r\n}\r\n\r\n.logo-skill {\r\n  color: #f39423; /* Orange for \"SKIL\" */\r\n}\r\n\r\n.logo-lab {\r\n  color: white; /* White for \"LAB\" */\r\n}\r\n\r\n\r\n.navbar-links {\r\n  list-style: none;\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.navbar-links li {\r\n  display: inline-block;\r\n}\r\n\r\n.nav-link-home {\r\n  text-decoration: none;\r\n  color: white; /* Default color */\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  transition: color 0.3s ease; /* Smooth transition on hover */\r\n}\r\n\r\n.nav-link-home:hover {\r\n  color: #f39423 !important; /* Orange color on hover */\r\n}\r\n\r\n\r\n\r\n\r\n.initpage-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    min-height: 100vh;\r\n    background-color: white;\r\n  }\r\n  \r\n  /* Header Styling */\r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .logo-section {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .logo-text {\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .eu-logo .eu-image {\r\n    width: 60px;\r\n  }\r\n  \r\n  /* Main Content Styling */\r\n  .content {\r\n    text-align: center;\r\n    padding: 40px;\r\n  }\r\n  \r\n  .content-heading {\r\n    font-size: 2.5rem;\r\n    color: #333;\r\n  }\r\n  \r\n  .content-description {\r\n    font-size: 1.2rem;\r\n    margin-top: 20px;\r\n    line-height: 1.5;\r\n    color: #555;\r\n  }\r\n  \r\n  /* Map Section Styling */\r\n  .map-section {\r\n    text-align: center;\r\n    margin-top: 40px;\r\n  }\r\n  \r\n  .map-image {\r\n    width: 80%;\r\n    max-width: 600px;\r\n  }\r\n  \r\n  /* Footer or Bottom EU Section */\r\n  .eu-logo-container {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    padding: 20px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
